module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TutorProfile"
  }, [_c('h1', {
    staticClass: "m-label",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n    先生基本情報\n  ")]), _vm._v(" "), (_vm.tutor.id == _vm.edit_id.tutor_id) ? [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.patchTutor(_vm.tutor)
      }
    }
  }, [_c('div', {
    staticClass: "m-box__inner"
  }, [_c('table', {
    staticClass: "m-detail"
  }, [(!_vm.valid) ? [_c('tr', [_c('th', [_vm._v("エラー")]), _vm._v(" "), _c('td', {
    staticClass: "errors"
  }, [_c('div', [_vm._v(_vm._s(_vm.errors) + "が入力されていません")])])])] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.tutor.id))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("user_id")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.tutor.user_id))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("営業所")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.offices,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "営業所"
    },
    model: {
      value: (_vm.watch.office_id),
      callback: function($$v) {
        _vm.$set(_vm.watch, "office_id", $$v)
      },
      expression: "watch.office_id"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("状態")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "state_0"
    }
  }, [_vm._v("未選択")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.state),
      expression: "tutor.state"
    }],
    attrs: {
      "type": "radio",
      "name": "state",
      "required": "",
      "id": "state_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.state, "0")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "state", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "state_1"
    }
  }, [_vm._v("指導可能")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.state),
      expression: "tutor.state"
    }],
    attrs: {
      "type": "radio",
      "name": "state",
      "id": "state_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.state, "1")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "state", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "state_2"
    }
  }, [_vm._v("指導不可")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.state),
      expression: "tutor.state"
    }],
    attrs: {
      "type": "radio",
      "name": "state",
      "id": "state_2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.state, "2")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "state", "2")
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("登録日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.registration_date),
      expression: "tutor.registration_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "登録日"
    },
    domProps: {
      "value": (_vm.tutor.registration_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "registration_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("名前")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.f_name),
      expression: "tutor.f_name"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.f_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "f_name", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.l_name),
      expression: "tutor.l_name"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.l_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "l_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("かな")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.f_name_kana),
      expression: "tutor.f_name_kana"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.tutor.f_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "f_name_kana", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.l_name_kana),
      expression: "tutor.l_name_kana"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.tutor.l_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "l_name_kana", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("性別")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "gender_0"
    }
  }, [_vm._v("未選択")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.gender),
      expression: "tutor.gender"
    }],
    attrs: {
      "type": "radio",
      "id": "gender_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.gender, "0")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "gender", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gender_1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.gender),
      expression: "tutor.gender"
    }],
    attrs: {
      "type": "radio",
      "id": "gender_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.gender, "1")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "gender", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gender_2"
    }
  }, [_vm._v("女")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.gender),
      expression: "tutor.gender"
    }],
    attrs: {
      "type": "radio",
      "id": "gender_2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.gender, "2")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "gender", "2")
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("生年月日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.birthday),
      expression: "tutor.birthday"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "生年月日"
    },
    domProps: {
      "value": (_vm.tutor.birthday)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "birthday", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("年齢")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcAge))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("郵便番号")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.zip),
      expression: "tutor.zip"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.zip)
    },
    on: {
      "keyup": _vm.getYubin,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("都道府県")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.prefs,
      "label": "name",
      "searchable": true,
      "show-labels": false,
      "placeholder": "都道府県"
    },
    model: {
      value: (_vm.watch.pref),
      callback: function($$v) {
        _vm.$set(_vm.watch, "pref", $$v)
      },
      expression: "watch.pref"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("市区町村・番地")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.address1),
      expression: "tutor.address1"
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.tutor.address1)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "address1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("建物名・部屋番号")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.address2),
      expression: "tutor.address2"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.address2)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "address2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "cllass": "req"
    }
  }, [_vm._v("携帯TEL")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.tel1),
      expression: "tutor.tel1"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "11",
      "minlength": "10",
      "placeholder": "携帯TEL"
    },
    domProps: {
      "value": (_vm.tutor.tel1)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "tel1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("固定TEL")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.tel2),
      expression: "tutor.tel2"
    }],
    attrs: {
      "type": "text",
      "maxlength": "11",
      "minlength": "10",
      "placeholder": "固定TEL"
    },
    domProps: {
      "value": (_vm.tutor.tel2)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "tel2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("MAIL1")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.mail1),
      expression: "tutor.mail1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.mail1)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "mail1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("MAIL2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.mail2),
      expression: "tutor.mail2"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.mail2)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "mail2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家郵便番号")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.home_zip),
      expression: "tutor.home_zip"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.home_zip)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "home_zip", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家/都道府県")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.prefs,
      "label": "name",
      "searchable": true,
      "show-labels": false,
      "placeholder": "実家/都道府県"
    },
    model: {
      value: (_vm.watch.home_pref),
      callback: function($$v) {
        _vm.$set(_vm.watch, "home_pref", $$v)
      },
      expression: "watch.home_pref"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家/市区町村・番地")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.home_address1),
      expression: "tutor.home_address1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.home_address1)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "home_address1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家/建物名・部屋番号")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.home_address2),
      expression: "tutor.home_address2"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.home_address2)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "home_address2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家TEL")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.home_tel),
      expression: "tutor.home_tel"
    }],
    attrs: {
      "type": "text",
      "maxlength": "11",
      "minlength": "10",
      "placeholder": "実家TEL"
    },
    domProps: {
      "value": (_vm.tutor.home_tel)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "home_tel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学校名")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.school_name),
      expression: "tutor.school_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.school_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "school_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("区分")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.school_stage,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "区分"
    },
    model: {
      value: (_vm.watch.school_stage),
      callback: function($$v) {
        _vm.$set(_vm.watch, "school_stage", $$v)
      },
      expression: "watch.school_stage"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学部")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.department),
      expression: "tutor.department"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.department)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "department", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("旧学年")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.old_grade,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "旧学年"
    },
    model: {
      value: (_vm.watch.old_grade),
      callback: function($$v) {
        _vm.$set(_vm.watch, "old_grade", $$v)
      },
      expression: "watch.old_grade"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学年")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcGrade))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("留年・浪人")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.grade_flag),
      expression: "tutor.grade_flag"
    }],
    attrs: {
      "type": "number",
      "placeholder": "留年・浪人"
    },
    domProps: {
      "value": (_vm.tutor.grade_flag)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "grade_flag", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("文系/理系")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "department_type_0"
    }
  }, [_vm._v("未選択")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.department_type),
      expression: "tutor.department_type"
    }],
    attrs: {
      "type": "radio",
      "id": "department_type_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.department_type, "0")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "department_type", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "department_type_1"
    }
  }, [_vm._v("文系")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.department_type),
      expression: "tutor.department_type"
    }],
    attrs: {
      "type": "radio",
      "id": "department_type_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.department_type, "1")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "department_type", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "department_type_2"
    }
  }, [_vm._v("理系")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.department_type),
      expression: "tutor.department_type"
    }],
    attrs: {
      "type": "radio",
      "id": "department_type_2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.department_type, "2")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "department_type", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "department_type_3"
    }
  }, [_vm._v("他")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.department_type),
      expression: "tutor.department_type"
    }],
    attrs: {
      "type": "radio",
      "id": "department_type_3",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.department_type, "3")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "department_type", "3")
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("サークル")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.club),
      expression: "tutor.club"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.club)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "club", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("高校部活")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.high_school_club),
      expression: "tutor.high_school_club"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.high_school_club)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "high_school_club", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("出身高校")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.high_school_name),
      expression: "tutor.high_school_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.high_school_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "high_school_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("移動手段")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "car"
    }
  }, [_vm._v("車")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.transportation_car),
      expression: "watch.transportation_car"
    }],
    attrs: {
      "type": "checkbox",
      "id": "car"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.transportation_car) ? _vm._i(_vm.watch.transportation_car, null) > -1 : (_vm.watch.transportation_car)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.transportation_car,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "transportation_car", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "transportation_car", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "transportation_car", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "bike"
    }
  }, [_vm._v("バイク")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.transportation_bike),
      expression: "watch.transportation_bike"
    }],
    attrs: {
      "type": "checkbox",
      "id": "bike"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.transportation_bike) ? _vm._i(_vm.watch.transportation_bike, null) > -1 : (_vm.watch.transportation_bike)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.transportation_bike,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "transportation_bike", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "transportation_bike", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "transportation_bike", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "scooters"
    }
  }, [_vm._v("原付")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.transportation_scooters),
      expression: "watch.transportation_scooters"
    }],
    attrs: {
      "type": "checkbox",
      "id": "scooters"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.transportation_scooters) ? _vm._i(_vm.watch.transportation_scooters, null) > -1 : (_vm.watch.transportation_scooters)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.transportation_scooters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "transportation_scooters", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "transportation_scooters", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "transportation_scooters", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "bicycle"
    }
  }, [_vm._v("自転車")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.transportation_bicycle),
      expression: "watch.transportation_bicycle"
    }],
    attrs: {
      "type": "checkbox",
      "id": "bicycle"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.transportation_bicycle) ? _vm._i(_vm.watch.transportation_bicycle, null) > -1 : (_vm.watch.transportation_bicycle)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.transportation_bicycle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "transportation_bicycle", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "transportation_bicycle", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "transportation_bicycle", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "train"
    }
  }, [_vm._v("電車")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.transportation_train),
      expression: "watch.transportation_train"
    }],
    attrs: {
      "type": "checkbox",
      "id": "train"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.transportation_train) ? _vm._i(_vm.watch.transportation_train, null) > -1 : (_vm.watch.transportation_train)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.transportation_train,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "transportation_train", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "transportation_train", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "transportation_train", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "none"
    }
  }, [_vm._v("無し")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.transportation_none),
      expression: "watch.transportation_none"
    }],
    attrs: {
      "type": "checkbox",
      "id": "none"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.transportation_none) ? _vm._i(_vm.watch.transportation_none, null) > -1 : (_vm.watch.transportation_none)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.transportation_none,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "transportation_none", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "transportation_none", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "transportation_none", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("最寄駅")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.nearest_station),
      expression: "tutor.nearest_station"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.nearest_station)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "nearest_station", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("受験経験")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "exam_s"
    }
  }, [_vm._v("小学")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.exam_s),
      expression: "watch.exam_s"
    }],
    attrs: {
      "type": "checkbox",
      "id": "exam_s"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.exam_s) ? _vm._i(_vm.watch.exam_s, null) > -1 : (_vm.watch.exam_s)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.exam_s,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "exam_s", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "exam_s", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "exam_s", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "exam_c"
    }
  }, [_vm._v("中学")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.exam_c),
      expression: "watch.exam_c"
    }],
    attrs: {
      "type": "checkbox",
      "id": "exam_c"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.exam_c) ? _vm._i(_vm.watch.exam_c, null) > -1 : (_vm.watch.exam_c)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.exam_c,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "exam_c", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "exam_c", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "exam_c", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "exam_k"
    }
  }, [_vm._v("高校")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.exam_k),
      expression: "watch.exam_k"
    }],
    attrs: {
      "type": "checkbox",
      "id": "exam_k"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.exam_k) ? _vm._i(_vm.watch.exam_k, null) > -1 : (_vm.watch.exam_k)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.exam_k,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "exam_k", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "exam_k", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "exam_k", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "exam_d"
    }
  }, [_vm._v("大学")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.exam_d),
      expression: "watch.exam_d"
    }],
    attrs: {
      "type": "checkbox",
      "id": "exam_d"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.exam_d) ? _vm._i(_vm.watch.exam_d, null) > -1 : (_vm.watch.exam_d)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.exam_d,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "exam_d", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "exam_d", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "exam_d", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("家教・塾講経験")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "experience_tutor"
    }
  }, [_vm._v("家庭教師")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.experience_tutor),
      expression: "watch.experience_tutor"
    }],
    attrs: {
      "type": "checkbox",
      "id": "experience_tutor"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.experience_tutor) ? _vm._i(_vm.watch.experience_tutor, null) > -1 : (_vm.watch.experience_tutor)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.experience_tutor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "experience_tutor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "experience_tutor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "experience_tutor", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "experience_cram"
    }
  }, [_vm._v("塾講師")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.experience_cram),
      expression: "watch.experience_cram"
    }],
    attrs: {
      "type": "checkbox",
      "id": "experience_cram"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.experience_cram) ? _vm._i(_vm.watch.experience_cram, null) > -1 : (_vm.watch.experience_cram)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.experience_cram,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "experience_cram", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "experience_cram", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "experience_cram", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "experience_none"
    }
  }, [_vm._v("無し")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.experience_none),
      expression: "watch.experience_none"
    }],
    attrs: {
      "type": "checkbox",
      "id": "experience_none"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.experience_none) ? _vm._i(_vm.watch.experience_none, null) > -1 : (_vm.watch.experience_none)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.experience_none,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "experience_none", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "experience_none", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "experience_none", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考(家教経験)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.experience_tutor_note),
      expression: "tutor.experience_tutor_note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.experience_tutor_note)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "experience_tutor_note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考(塾講経験)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.experience_cram_note),
      expression: "tutor.experience_cram_note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.experience_cram_note)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "experience_cram_note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "background": "#eee"
    }
  }, [_vm._v("登録媒体")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#eee"
    }
  }, [_vm._v(_vm._s(_vm.tutor.medium))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考(登録媒体)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.medium_note),
      expression: "tutor.medium_note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tutor.medium_note)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "medium_note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HP/パンフ掲載")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "published_0"
    }
  }, [_vm._v("未選択")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.published),
      expression: "tutor.published"
    }],
    attrs: {
      "type": "radio",
      "id": "published_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.published, "0")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "published", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "published_1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.published),
      expression: "tutor.published"
    }],
    attrs: {
      "type": "radio",
      "id": "published_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.published, "1")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "published", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "published_2"
    }
  }, [_vm._v("NG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.published),
      expression: "tutor.published"
    }],
    attrs: {
      "type": "radio",
      "id": "published_2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.published, "2")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "published", "2")
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("情報発信")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "information_0"
    }
  }, [_vm._v("未選択")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.information),
      expression: "tutor.information"
    }],
    attrs: {
      "type": "radio",
      "name": "information",
      "required": "",
      "id": "information_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.information, "0")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "information", "0")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "information_1"
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.information),
      expression: "tutor.information"
    }],
    attrs: {
      "type": "radio",
      "name": "information",
      "id": "information_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.information, "1")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "information", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "information_2"
    }
  }, [_vm._v("NG")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.information),
      expression: "tutor.information"
    }],
    attrs: {
      "type": "radio",
      "name": "information",
      "id": "information_2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.information, "2")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "information", "2")
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("印象ランク")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "impression_0"
    }
  }, [_vm._v("未選択")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression),
      expression: "tutor.impression"
    }],
    attrs: {
      "type": "radio",
      "id": "impression_0",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.impression, "0")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "impression", "0")
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "impression_1"
    }
  }, [_vm._v("AA")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression),
      expression: "tutor.impression"
    }],
    attrs: {
      "type": "radio",
      "id": "impression_1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.impression, "1")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "impression", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "impression_2"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression),
      expression: "tutor.impression"
    }],
    attrs: {
      "type": "radio",
      "id": "impression_2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.impression, "2")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "impression", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "impression_3"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression),
      expression: "tutor.impression"
    }],
    attrs: {
      "type": "radio",
      "id": "impression_3",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.impression, "3")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "impression", "3")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "impression_4"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression),
      expression: "tutor.impression"
    }],
    attrs: {
      "type": "radio",
      "id": "impression_4",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.impression, "4")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "impression", "4")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "impression_5"
    }
  }, [_vm._v("Z")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression),
      expression: "tutor.impression"
    }],
    attrs: {
      "type": "radio",
      "id": "impression_5",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.impression, "5")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "impression", "5")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "impression_6"
    }
  }, [_vm._v("紹介不可")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression),
      expression: "tutor.impression"
    }],
    attrs: {
      "type": "radio",
      "id": "impression_6",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.tutor.impression, "6")
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        return _vm.$set(_vm.tutor, "impression", "6")
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("印象ランク備考")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.impression_note),
      expression: "tutor.impression_note"
    }],
    domProps: {
      "value": (_vm.tutor.impression_note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "impression_note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("研修")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "training"
    }
  }, [_vm._v("研修")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.training),
      expression: "watch.training"
    }],
    attrs: {
      "type": "checkbox",
      "id": "training"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.training) ? _vm._i(_vm.watch.training, null) > -1 : (_vm.watch.training)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.training,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "training", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "training", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "training", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("研修備考")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.training_note),
      expression: "tutor.training_note"
    }],
    domProps: {
      "value": (_vm.tutor.training_note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "training_note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SSK")]), _vm._v(" "), _c('td', {
    staticClass: "checkbox"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "ssk"
    }
  }, [_vm._v("SSK")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.watch.ssk),
      expression: "watch.ssk"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ssk"
    },
    domProps: {
      "checked": Array.isArray(_vm.watch.ssk) ? _vm._i(_vm.watch.ssk, null) > -1 : (_vm.watch.ssk)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "change": function($event) {
        var $$a = _vm.watch.ssk,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.watch, "ssk", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.watch, "ssk", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.watch, "ssk", $$c)
        }
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutor.note),
      expression: "tutor.note"
    }],
    domProps: {
      "value": (_vm.tutor.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutor, "note", $event.target.value)
      }
    }
  })])])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('btn', {
    staticClass: "m-btn m-btn--default"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("更新")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn m-btn--default cancel",
    attrs: {
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelTutor(_vm.tutor)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("キャンセル")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.tutor.id !== _vm.edit_id.tutor_id) ? [_c('div', {
    staticClass: "m-box__inner"
  }, [_c('table', {
    staticClass: "m-detail"
  }, [(!_vm.valid) ? [_c('tr', [_c('th', [_vm._v("エラー")]), _vm._v(" "), _c('td', {
    staticClass: "errors"
  }, [_c('div', [_vm._v(_vm._s(_vm.errors) + "が入力されていません")])])])] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("user_id")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.user_id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("営業所")]), _vm._v(" "), (_vm.tutor.office_id) ? [_c('td', [_vm._v(_vm._s(_vm.officeName))])] : [_c('td')]], 2), _vm._v(" "), _c('tr', [_c('th', [_vm._v("状態")]), _vm._v(" "), (_vm.tutor.state === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.state === 1) ? _c('td', [_vm._v("指導可")]) : _vm._e(), _vm._v(" "), (_vm.tutor.state === 2) ? _c('td', [_vm._v("指導不可")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("登録日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.registration_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("名前")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.f_name) + " " + _vm._s(_vm.tutor.l_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("かな")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.f_name_kana) + " " + _vm._s(_vm.tutor.l_name_kana))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("性別")]), _vm._v(" "), (_vm.tutor.gender === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.gender === 1) ? _c('td', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.tutor.gender === 2) ? _c('td', [_vm._v("女")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("生年月日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.birthday))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("年齢")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calcAge))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("郵便番号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.zip))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("都道府県")]), _vm._v(" "), (_vm.tutor.pref) ? [_c('td', [_vm._v(_vm._s(_vm.prefName))])] : [_c('td')]], 2), _vm._v(" "), _c('tr', [_c('th', [_vm._v("市区町村・番地")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.address1))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("建物名・部屋番号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.address2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("携帯TEL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.tel1))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("固定TEL")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.tel2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("MAIL1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.mail1))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("MAIL2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.mail2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家郵便番号")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v(_vm._s(_vm.tutor.home_zip))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家/都道府県")]), _vm._v(" "), (_vm.tutor.home_pref) ? [_c('td', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v(_vm._s(_vm.homePrefName))])] : [_c('td')]], 2), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家/市区町村・番地")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v(_vm._s(_vm.tutor.home_address1))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家/建物名・部屋番号")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v(_vm._s(_vm.tutor.home_address2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("実家TEL")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v(_vm._s(_vm.tutor.home_tel))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学校名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.school_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("区分")]), _vm._v(" "), (_vm.tutor.school_stage === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 1) ? _c('td', [_vm._v("大学4年制")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 2) ? _c('td', [_vm._v("大学院")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 3) ? _c('td', [_vm._v("専門2年制")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 4) ? _c('td', [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 5) ? _c('td', [_vm._v("大学6年制")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 6) ? _c('td', [_vm._v("専門3年制")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 7) ? _c('td', [_vm._v("短大2年制")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 8) ? _c('td', [_vm._v("高専")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 9) ? _c('td', [_vm._v("大学")]) : _vm._e(), _vm._v(" "), (_vm.tutor.school_stage === 10) ? _c('td', [_vm._v("専門")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学部")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.department))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("旧学年")]), _vm._v(" "), (_vm.tutor.old_grade === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 1) ? _c('td', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 2) ? _c('td', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 3) ? _c('td', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 4) ? _c('td', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 5) ? _c('td', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 6) ? _c('td', [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 7) ? _c('td', [_vm._v("M1")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 8) ? _c('td', [_vm._v("M2")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 9) ? _c('td', [_vm._v("D1")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 10) ? _c('td', [_vm._v("D2")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 11) ? _c('td', [_vm._v("卒業")]) : _vm._e(), _vm._v(" "), (_vm.tutor.old_grade === 12) ? _c('td', [_vm._v("中退")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calcGrade))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("留年・浪人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.grade_flag))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("文系/理系")]), _vm._v(" "), (_vm.tutor.department_type === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.department_type === 1) ? _c('td', [_vm._v("文系")]) : _vm._e(), _vm._v(" "), (_vm.tutor.department_type === 2) ? _c('td', [_vm._v("理系")]) : _vm._e(), _vm._v(" "), (_vm.tutor.department_type === 3) ? _c('td', [_vm._v("他")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("サークル")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.club))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("高校部活")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.high_school_club))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("出身高校")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.high_school_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("移動手段")]), _vm._v(" "), _c('td', _vm._l((_vm.transportations), function(list, index) {
    return _c('span', {
      key: index.id
    }, [_vm._v(_vm._s(list) + " ")])
  }), 0)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("最寄駅")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.nearest_station))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("受験経験")]), _vm._v(" "), _c('td', _vm._l((_vm.exams), function(list, index) {
    return _c('span', {
      key: index.id
    }, [_vm._v(_vm._s(list) + " ")])
  }), 0)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("指導経験")]), _vm._v(" "), _c('td', _vm._l((_vm.experiences), function(list, index) {
    return _c('span', {
      key: index.id
    }, [_vm._v(_vm._s(list) + " ")])
  }), 0)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考(家庭教師経験)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.experience_tutor_note))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考(塾講師経験)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.experience_cram_note))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "background": "#eee"
    }
  }, [_vm._v("登録媒体")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "#eee"
    }
  }, [_vm._v(_vm._s(_vm.tutor.medium))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考(登録媒体)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.medium_note))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HP/パンフ掲載")]), _vm._v(" "), (_vm.tutor.published === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.published === 1) ? _c('td', [_vm._v("OK")]) : _vm._e(), _vm._v(" "), (_vm.tutor.published === 2) ? _c('td', [_vm._v("NG")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("情報発信")]), _vm._v(" "), (_vm.tutor.information === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.information === 1) ? _c('td', [_vm._v("OK")]) : _vm._e(), _vm._v(" "), (_vm.tutor.information === 2) ? _c('td', [_vm._v("NG")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("印象ランク")]), _vm._v(" "), (_vm.tutor.impression === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.tutor.impression === 1) ? _c('td', [_vm._v("AA")]) : _vm._e(), _vm._v(" "), (_vm.tutor.impression === 2) ? _c('td', [_vm._v("A")]) : _vm._e(), _vm._v(" "), (_vm.tutor.impression === 3) ? _c('td', [_vm._v("B")]) : _vm._e(), _vm._v(" "), (_vm.tutor.impression === 4) ? _c('td', [_vm._v("C")]) : _vm._e(), _vm._v(" "), (_vm.tutor.impression === 5) ? _c('td', [_vm._v("Z")]) : _vm._e(), _vm._v(" "), (_vm.tutor.impression === 6) ? _c('td', [_vm._v("紹介不可")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("印象ランク備考")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tutor.impression_note))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("研修")]), _vm._v(" "), (_vm.tutor.training === 0) ? _c('td', [_vm._v("未")]) : _vm._e(), _vm._v(" "), (_vm.tutor.training === 1) ? _c('td', [_vm._v("済")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("研修備考")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.tutor.training_note))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SSK")]), _vm._v(" "), (_vm.tutor.ssk === 0) ? _c('td', [_vm._v("未")]) : _vm._e(), _vm._v(" "), (_vm.tutor.ssk === 1) ? _c('td', [_vm._v("済")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.tutor.note))])])], 2)]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.edit(_vm.tutor)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("編集")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c734c40c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Profile/TutorProfile.vue
// module id = 1454
// module chunks = 0